'use strict';

angular.module('TurneroApp').component('coAppExternaView', {
    bindings: {
        centroAtencionSeleccionado: '<',
        data: '<'
    },
    controller: [
         'utilsService',
         'TurneroAppConstant',
         'appExternaService',
         function (utilsService, TurneroAppConstant, appExternaService) {
             var ctrl = this;
             ctrl.Tipo_Columna = TurneroAppConstant.Tipo_Columnas;


             ctrl.$onChanges = function () {
                 if (ctrl.data) {
                     ctrl.appExterna = ctrl.data;
                 }
             }

         }],
    template: require('./appExternaView.html')
});



// WEBPACK FOOTER //
// ./app/components/appExterna/appExternaViewComponent.js